import React from "react";

export default function Phonetic(props) {
    return (
        <div className="Phonetic">{props.phonetic}</div>
    );
}